import React from "react";
import { FiMail, FiArrowRight } from "react-icons/fi";

export default function CTA() {
  return (
    <section className="relative overflow-hidden border-y-2 border-stone-900/10 dark:border-stone-100/10">
      <div className="max-w-6xl mx-auto px-6 py-16">
        <div className="relative border-2 border-black dark:border-white bg-black text-white dark:bg-white dark:text-black p-8 sm:p-12">
          <h3 className="font-display text-2xl sm:text-4xl font-semibold max-w-xl">
            Let's build something that ships.
          </h3>
          <p className="mt-4 text-white/70 dark:text-black/70 max-w-lg leading-relaxed">
            Send a short brief: stack, timeline, what "done" looks like. I'll answer within 24 hours with
            honest next steps.
          </p>
          <div className="mt-8 flex flex-wrap items-center gap-3">
            <a
              href="mailto:hello@natnaeladane.dev"
              className="inline-flex items-center gap-2 bg-white text-black dark:bg-black dark:text-white font-mono font-bold uppercase tracking-wider text-xs px-5 py-3 hover:bg-stone-200 dark:hover:bg-stone-800 transition-colors"
            >
              <FiMail className="shrink-0" aria-hidden /> Email
            </a>
            <a
              href="https://calendly.com/natnaeladane21/30min"
              target="_blank"
              rel="noreferrer"
              className="inline-flex items-center gap-2 border-2 border-white/50 dark:border-black/50 font-mono font-bold uppercase tracking-wider text-xs px-5 py-3 hover:border-white dark:hover:border-black transition-colors"
            >
              Book 30 min
            </a>
            <a
              href="#projects"
              className="inline-flex items-center gap-2 text-sm font-medium text-white/60 dark:text-black/60 hover:text-white dark:hover:text-black transition-colors"
            >
              View projects <FiArrowRight className="shrink-0" aria-hidden />
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
